module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile.limit) ? _c('nav', {
    staticClass: "navbar navbar-light bg-faded",
    staticStyle: {
      "background-color": "#DC143C"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/",
      "id": "color-me"
    }
  }, [_c('b', [_c('img', {
    attrs: {
      "src": require('@/assets/abeja_logo.png'),
      "width": "50",
      "height": "50"
    }
  }), _vm._v("\n     Abeja merchandise store ")])]), _vm._v(" "), _c('span', {
    staticClass: "navbar-text float-xs-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary navbar-btn",
    attrs: {
      "to": "/Cart",
      "tag": "button"
    }
  }, [_vm._v("Cart")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success navbar-btn",
    attrs: {
      "to": "/",
      "tag": "button"
    }
  }, [_vm._v("Store")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "navbar-text float-xs-right",
    attrs: {
      "id": "color-text"
    }
  }, [_vm._v("\n      Hello "), _c('strong', [_vm._v(_vm._s(_vm.fullName))]), _vm._v(", your credit limit is\n       "), _c('shopping-cart-limit', {
    attrs: {
      "limit": _vm.profile.limit
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43cb30b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PageHeader.vue
// module id = 270
// module chunks = 1